<script setup lang="ts">
import { Head } from '@inertiajs/vue3'
import PageHeading from "@/Components/Headings/PageHeading.vue"
import { PageHeading as PageHeadingTS } from '@/types/PageHeading'
import { ref, onMounted } from "vue"

import Icon from '@/Components/Utils/Icon.vue'
import CountUp from 'vue-countup-v3'
import { useFormatCurrency } from '@/Composables/useFormatCurrency'
import { useFormatNumber } from '@/Composables/useFormatNumber'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { Fieldset } from 'primevue'
import Chart from 'primevue/chart'
// import {  } from '@fas'
// import { library } from '@fortawesome/fontawesome-svg-core'
// library.add()

const props = defineProps<{
    pageHead?: PageHeadingTS
    title?: string
    stats_box: {
        total: {
            value: number
            unit?: string
        }
        not_started: {
            value: number
            unit?: string
        }
        pra_cetak: {
            value: number
            unit?: string
        }
        cetak: {
            value: number
            unit?: string
        }
        finishing: {
            value: number
            unit?: string
        }
        validated: {
            value: number
            unit?: string
        }
    }
    stats_pie: {
        labels: string[]
        datasets: {
            label: string
            data: number[]
            backgroundColor: string[]
        }[]
    }
}>()

const setChartOptions = () => {
    const documentStyle = getComputedStyle(document.documentElement)
    const textColor = documentStyle.getPropertyValue('--p-text-color')

    return {
        plugins: {
            legend: {
                labels: {
                    usePointStyle: true,
                    color: textColor
                }
            }
        }
    };
};
const chartOptions = ref()
onMounted(() => {
    chartOptions.value = setChartOptions()
})

</script>

<template>

    <Head :title="title" />
    <PageHeading :data="pageHead" />

    <div class="mx-8 mt-8 gap-x-6 gap-y-8 xl:gap-x-6 grid lg:grid-cols-2">
        <div class="w-full md:max-w-xl grid grid-cols-2 gap-x-2 gap-y-1.5 md:grid-cols-2">            
            <div class="bg-cyan-100 md:col-span-2 relative px-4 py-6 sm:px-6 rounded border border-cyan-400 text-cyan-700">
                <p class="text-sm/6 font-medium opacity-70">
                    Total manufactures
                    <FontAwesomeIcon v-tooltip="'Termasuk yang dicancel'" icon='fal fa-info-circle' class='' fixed-width aria-hidden='true' />
                </p>
                <p class="mt-2 flex items-baseline gap-x-2">
                    <span class="text-4xl font-semibold tracking-tight tabular-nums">
                        <CountUp :endVal='stats_box.total.value' :duration='1.5' :scrollSpyOnce='true' :options='{
                            formattingFn: (value: number) => useFormatNumber(value)
                        }' />
                    </span>
                    <span class="">{{ stats_box.total.unit }}</span>
                </p>
            </div>
            
            <div class="relative px-4 py-6 sm:px-6 rounded border border-gray-300">
                <p class="text-sm/6 font-medium text-gray-400">Belum dimulai</p>
                <p class="mt-2 flex items-baseline gap-x-2">
                    <span class="text-4xl font-semibold tracking-tight">
                        <CountUp :endVal='stats_box.not_started.value' :duration='1.5' :scrollSpyOnce='true' :options='{
                            formattingFn: (value: number) => useFormatNumber(value)
                        }' />
                    </span>
                </p>
            </div>
            
            <div class="relative px-4 py-6 sm:px-6 rounded border border-gray-300">
                <p class="text-sm/6 font-medium text-gray-400">Pracetak</p>
                <p class="mt-2 flex items-baseline gap-x-2">
                    <span class="text-4xl font-semibold tracking-tight">
                        <CountUp :endVal='stats_box.pra_cetak.value' :duration='1.5' :scrollSpyOnce='true' :options='{
                            formattingFn: (value: number) => useFormatNumber(value)
                        }' />
                    </span>
                </p>
            </div>

            <div class="relative px-4 py-6 sm:px-6 rounded border border-gray-300">
                <p class="text-sm/6 font-medium text-gray-400">Cetak</p>
                <p class="mt-2 flex items-baseline gap-x-2">
                    <span class="text-4xl font-semibold tracking-tight">
                        <CountUp :endVal='stats_box.cetak.value' :duration='1.5' :scrollSpyOnce='true' :options='{
                            formattingFn: (value: number) => useFormatNumber(value)
                        }' />
                    </span>
                </p>
            </div>

            <div class="relative px-4 py-6 sm:px-6 rounded border border-gray-300">
                <p class="text-sm/6 font-medium text-gray-400">Finishing</p>
                <p class="mt-2 flex items-baseline gap-x-2">
                    <span class="text-4xl font-semibold tracking-tight">
                        <CountUp :endVal='stats_box.finishing.value' :duration='1.5' :scrollSpyOnce='true' :options='{
                            formattingFn: (value: number) => useFormatNumber(value)
                        }' />
                    </span>
                </p>
            </div>

            <!-- <div class="relative px-4 py-6 sm:px-6 rounded border border-gray-300">
                <p class="text-sm/6 font-medium text-gray-400">Validasi</p>
                <p class="mt-2 flex items-baseline gap-x-2">
                    <span class="text-4xl font-semibold tracking-tight">
                        <CountUp :endVal='stats_box.validated.value' :duration='1.5' :scrollSpyOnce='true' :options='{
                            formattingFn: (value: number) => useFormatNumber(value)
                        }' />
                    </span>
                </p>
            </div> -->
        </div>

        <div class="-mt-4 pb-1 justify-self-end flex justify-end w-full md:w-96">
            <Fieldset legend="Dapat diproses hari ini" class="h-fit w-full">
                <Chart type="pie" :data="stats_pie" :options="chartOptions" class="w-full md:w-full" />
            </Fieldset>
        </div>
            <!-- <pre>{{ xx }}</pre>
            <pre>{{ stats_pie }}</pre> -->
    </div>
</template>